import React, { useState } from "react";
import styles from "./StudentNewLeave.module.css";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import { FaUserPlus } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import { LuUpload } from "react-icons/lu";
import { saveLeave } from "../../redux/slices/leaveSlice";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
// ✅ Each student now has a unique ID
const dummyStudents = [
  { id: "s1", name: "John" },
  { id: "s2", name: "Steeve" },
  { id: "s3", name: "John" },
  { id: "s4", name: "Steeve" },
  { id: "s5", name: "John" },
  { id: "s6", name: "Steeve" },
  { id: "s7", name: "John" },
  { id: "s8", name: "Steeve" },
  { id: "s9", name: "John" },
  { id: "s10", name: "Steeve" },
];

const StudentNewLeave = () => {
  const dispatch = useDispatch();
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedDate, setSelectedDate] = useState("");

  const [uploadedFile, setUploadedFile] = useState(null);


  const [leaveType, setLeaveType] = useState("");
  const [reason, setReason] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const handleCheckboxChange = (id) => {
    setSelectedStudents((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const filteredStudents = dummyStudents.filter((student) =>
    student.name.toLowerCase().includes(search.toLowerCase())
  );
  const handleClose = () => {
    dispatch(closeModal());
  };
  const handleSave = () => {
    const leaveEntry = {
      fromDate,
      toDate,
      leaveType,
      reason,
      attachment: uploadedFile,
    };

    dispatch(saveLeave(leaveEntry));
    dispatch(closeModal());
  };

  const handleCancel = () => {
    setSelectedStudents([]); // clear all checkboxes
    setSearch("");
    setLeaveType("");
    setReason("");
    setFromDate("");
    setToDate("");
    // clear search input
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeadingAndIcon icon={<FaUserPlus />} heading="New Leave" />
        <ToClose onClose={handleClose} />
      </div>

      <div className={styles.sectionCard}>
        <div className={styles.sectionHeader}>
          <HeadingAndIcon icon={<FaUserPlus />} heading="Select Student" />
        </div>
        <div className={styles.studentdata}>
          <div className={styles.controls}>
            <SearchBar
              placeholder="Search Student"
              onChange={(e) => setSearch(e.target.value)}
            />
            <Dropdown
              bgColor="var(--Utility_Color1)"
              label="Room"
              options={["Room A", "Room B"]}
            />
          </div>

          <div className={styles.listHeader}>
            <label>
              <input
                type="checkbox"
                checked={selectedStudents.length === filteredStudents.length}
                onChange={(e) =>
                  setSelectedStudents(
                    e.target.checked ? filteredStudents.map((s) => s.id) : []
                  )
                }
              />{" "}
              Select All
            </label>
            <span>{selectedStudents.length} Selected</span>
          </div>

          <div className={styles.grid}>
            {filteredStudents.map((student) => (
              <label key={student.id} className={styles.studentBox}>
                <input
                  type="checkbox"
                  checked={selectedStudents.includes(student.id)}
                  onChange={() => handleCheckboxChange(student.id)}
                />
                <span>{student.name}</span>
              </label>
            ))}
          </div>

          <div className={styles.footerActions}>
            <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
          </div>
        </div>
      </div>
      <div className={styles.sectionCard}>
        <div className={styles.sectionHeader}>
          <HeadingAndIcon icon={<FaUserPlus />} heading="Leave Details" />
        </div>

        <div className={styles.leaveDetails}>
          <div className={styles.row}>
            <div className={styles.wideInput}>
              <HeadingAndDropDown
                label="Type"
                name="leaveType"
                value={leaveType}
                onChange={(e) => setLeaveType(e.target.value)}
                required
                options={[
                  { label: "Sick", value: "sick" },
                  { label: "Casual", value: "casual" },
                  { label: "Emergency", value: "emergency" },
                ]}
                placeholder="Choose leave type"
              />
            </div>

            <div className={styles.smallInput}>
              <label className={styles.inputLabel}>From *</label>
              <CalendarInput
                label="Select Date"
                required
                value={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                background="var(--White_Color)"
                placeholderColor="var(--Grey_Color)"
                iconColor="var(--Grey_Color)"
                borderRadius="12px"
              />
            </div>

            <div className={styles.smallInput}>
              <label className={styles.inputLabel}>To *</label>
              <CalendarInput
                label="Select Date"
                required
                value={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                background="var(--White_Color)"
                placeholderColor="var(--Grey_Color)"
                iconColor="var(--Grey_Color)"
                borderRadius="12px"
              />
            </div>
          </div>

          <div className={styles.bottomRow}>
            <div className={styles.notesBlock}>
              <label className={styles.inputLabel}>Notes *</label>
              <textarea
                placeholder="Reason for Holiday"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                className={styles.textarea}
                required
              />
            </div>

            <div className={styles.uploadBlock}>
              <label className={styles.inputLabel}>Attachment</label>
              <div className={styles.uploadCard}>
                <label htmlFor="fileUpload" className={styles.uploadLabel}>
                  <LuUpload className={styles.uploadIcon} />
                  <span className={styles.uploadText}>
                    Browse and upload files from device
                  </span>
                </label>
                <input
                  type="file"
                  id="fileUpload"
                  onChange={(e) =>
                    console.log("Uploaded file:", e.target.files[0])
                  }
                  className={styles.hiddenInput}
                />
              </div>
            </div>
          </div>
          <div className={styles.footerActions}>
            <SaveAndCancel
              onSave={handleSave}
              onCancel={() => {
                setLeaveType("");
                setReason("");
                setFromDate("");
                setToDate("");
                setUploadedFile(null); // if using upload
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentNewLeave;
